import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Modal, Input, H3, Text, Small } from '@bigcommerce/big-design';

import { assignmentDelete } from '../../redux/actions/assignments';

const DeleteSupplierAssignmentModal = ({ payload, supplier, modalProductId, modalVariantId, modalOptions, modalProductName, modalAssignment, showDeleteSupplierAssignmentModal, setShowDeleteSupplierAssignmentModal, deleteAssignment }) => {
  const update = () => {
    let assignment = {
      product_id: modalProductId,
      variant_id: modalVariantId
    }

    deleteAssignment(payload, supplier.id, assignment);
    setShowDeleteSupplierAssignmentModal(false);
  }

  return(
    <Modal
      actions={[
        {
          text: 'Cancel',
          variant: 'subtle',
          onClick: () => setShowDeleteSupplierAssignmentModal(false),
        },
        { text: 'Delete Assignment', onClick: () => update() },
      ]}
      closeOnClickOutside={true}
      closeOnEscKey={true}
      header="Delete Assignment"
      isOpen={showDeleteSupplierAssignmentModal}
      onClose={() => setShowDeleteSupplierAssignmentModal(false)}
    >
      <H3><strong>Supplier</strong>: { supplier.supplier_name }</H3>
      <H3><strong>Product</strong>: {modalProductName}</H3>
      { modalOptions && modalOptions.map(option =>
          <li>
            <strong>{ option.option_display_name }</strong>: { option.label }
          </li>
        )
      }
      <Small>
        Current Supplier SKU: {modalAssignment.supplier_sku}<br/>
        Current Supplier Price: {modalAssignment.supplier_price}<br/>
        Current MOQ: {modalAssignment.minimum_order}
      </Small>
    </Modal>
  )
}

const mapStateToProps = state => ({ 
});

const mapDispatchToProps = (dispatch) => ({
  deleteAssignment: (payload, supplierId, assignment) => dispatch(assignmentDelete(payload, supplierId, assignment)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteSupplierAssignmentModal);